import {SET_PICKER_DATE, SET_PICKUP_DATE_TIME} from 'new-constants/order-time.constants';
import {ORDER_TIME_SLOTS} from "../constants/api.constants";

export const setPickerDate = date => {
	return {
		type: SET_PICKER_DATE,
		date,
	};
};

export const setPickupDateTime = (date, time) => {
	return {
		type: SET_PICKUP_DATE_TIME,
		dismissError: ORDER_TIME_SLOTS,
		date,
		time,
	};
};
